import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { ProcessingStatItem } from '../ProcessingStatsItem';

export const RecordCount = ({ procStatsList, service }) => {
  return service === 'gps' ? (
    <ProcessingStatItem title="Record Count">
      <Table.Container title="">
        <Table.TableBody>
          <Table.Row>
            <Table.Cell>
              <b>Total Transactions</b>{' '}
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.totalTransactions}
            </Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
    </ProcessingStatItem>
  ) : (
    <ProcessingStatItem title="Record Count">
      <Table.Container title="">
        <Table.TableBody>
          <Table.Row>
            <Table.Cell>
              <b>Subscribers on File </b>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.subscribersOnFile}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Dependents on File </b>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.dependentsOnFile}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Total Records on File</b>{' '}
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.totalRecordsOnFile}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Subscriber Auto-Cancels </b>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.subscriberAutoCancels}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Dependent Auto-Cancels </b>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.dependentAutoCancels}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Total Auto-Cancels</b>{' '}
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.totalAutoCancels}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <b>Total Transactions</b>{' '}
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.recordCounts?.totalTransactions}
            </Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
    </ProcessingStatItem>
  );
};
